import { channels } from '../data';
import { SectionHeader } from './SectionHeader';

const icons = [
  'ri-emotion-happy-line',
  'ri-mic-line',
  'ri-film-line',
  'ri-run-line',
  'ri-smartphone-line',
  'ri-heart-pulse-line',
];

export default function Channels() {
  return (
    <section id="channels" className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          kicker="六大栏目分区"
          title="挑一个最对你胃口的瓜"
          desc="每个栏目都由封面驱动、独立更新，按题材把今天的热门瓜分开，想看哪块吃哪块。"
        />

        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:gap-5">
          {channels.map((channel, idx) => (
            <a
              key={channel.name}
              href="#feed"
              className="group relative flex h-44 flex-col justify-end overflow-hidden rounded-2xl md:h-56 lg:h-64"
            >
              <img
                src={channel.img}
                alt={channel.name}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/5"></div>
              <div className="relative p-3.5 text-background-50 md:p-5">
                <div className="flex items-center justify-between">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/20 text-base backdrop-blur-sm md:h-9 md:w-9">
                    <i className={icons[idx % icons.length]}></i>
                  </span>
                  <span className="text-xs text-background-50/80">
                    {channel.count} 条热门
                  </span>
                </div>
                <h3 className="font-heading mt-3 text-base font-bold md:text-xl">{channel.name}</h3>
                <p className="mt-0.5 text-xs text-background-50/85 md:text-sm">{channel.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}